export default {
  MENU_LINK: "MenuLink",
  SUBMENU_LINK: "SubMenuLink"
};
